// extracted by mini-css-extract-plugin
module.exports = {"container":"IconTile-module--container","icon":"IconTile-module--icon","title1":"IconTile-module--title1","title2":"IconTile-module--title2","subtitle":"IconTile-module--subtitle"};